
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { logger } from '@/utils/logger';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, session } = useAuth();
  const location = useLocation();

  logger.debug('🛡️ ProtectedRoute - Path:', location.pathname, 'Loading:', loading, 'User:', !!user, 'Session:', !!session);

  // SÉCURITÉ: Aucun bypass automatique autorisé
  // L'authentification est obligatoire dans tous les environnements

  if (loading) {
    logger.debug('⏳ ProtectedRoute - En attente de vérification auth...');
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'hsl(45, 15%, 96%)'
      }}>
        <img
          src="/octoveto-logo.webp"
          alt="OctoVeto"
          width="220"
          height="120"
          fetchPriority="high"
          style={{ width: '220px', height: 'auto', objectFit: 'contain', marginBottom: '2rem' }}
        />
        <div style={{ textAlign: 'center', padding: '1rem' }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '3px solid hsl(214.3, 31.8%, 91.4%)',
            borderRadius: '50%',
            borderTopColor: 'hsl(25, 100%, 50%)',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{ color: 'hsl(222.2, 84%, 20%)' }}>Vérification des permissions...</p>
        </div>
      </div>
    );
  }

  if (!user || !session) {
    logger.debug('❌ ProtectedRoute - Pas d\'utilisateur/session, redirection vers /auth');
    // Rediriger vers la page d'auth en sauvegardant la destination
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  logger.debug('✅ ProtectedRoute - Utilisateur autorisé, affichage du contenu');
  return <>{children}</>;
};

export default ProtectedRoute;
